<template>
    <span>{{count}}</span>
</template>
<script>
let timer = null
export default {
    computed: {
        count: {
            get() {
                if (this.value > 0) this.next(this.value)
                return parseInt(this.value)
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    props: {
        value: {
            type: Number,
            required: true,
        },
        speed: {
            type: Number,
            default: 1000,
        },
    },
    methods: {
        next(value) {
            clearTimeout(timer)
            value--
            timer = setTimeout(() => {
                this.$emit('input', value)
            }, this.speed)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Payment/components/components/countDown.vue